/* eslint-disable no-underscore-dangle */
import { initializeApp } from 'firebase/app';
import { getRemoteConfig, fetchAndActivate, getAll } from 'firebase/remote-config';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDERID,
  appId: process.env.REACT_APP_APP_ID,
};

export const initFirebase = async () => {
  const firebaseApp = initializeApp(firebaseConfig);
  const firebaseRemoteConfig = getRemoteConfig(firebaseApp);

  if (firebaseRemoteConfig) firebaseRemoteConfig.settings.minimumFetchIntervalMillis = 0;

  if (firebaseRemoteConfig) {
    try {
      await fetchAndActivate(firebaseRemoteConfig);
      const remoteFlags = await getAll(firebaseRemoteConfig);

      if (remoteFlags) {
        const {
          subProductionSubmitOrderBetweenRequestsPause,
          subProductionSubmitOrderChunkSize,
          subProductionUserAccess,
          productionSubmitOrderBetweenRequestsPause,
          productionSubmitOrderChunkSize,
          productionUserAccess,
        } = remoteFlags;
        const subProductionSubmitOrderBetweenRequestsPauseValue =
          subProductionSubmitOrderBetweenRequestsPause._value;
        const subProductionSubmitOrderChunkSizeValue = subProductionSubmitOrderChunkSize._value;
        const subProductionUserAccessValue = subProductionUserAccess._value;
        const productionSubmitOrderBetweenRequestsPauseValue =
          productionSubmitOrderBetweenRequestsPause._value;
        const productionSubmitOrderChunkSizeValue = productionSubmitOrderChunkSize._value;
        const productionUserAccessValue = productionUserAccess._value;
        const configObj = {
          subProductionSubmitOrderBetweenRequestsPauseValue,
          subProductionSubmitOrderChunkSizeValue,
          subProductionUserAccessValue,
          productionSubmitOrderBetweenRequestsPauseValue,
          productionSubmitOrderChunkSizeValue,
          productionUserAccessValue,
        };

        return configObj;
      }
    } catch {
      throw new Error();
    }
  }

  throw new Error();
};
